import classnames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import ActiveFilterButton from "../../components/ActiveFilterButton/ActiveFilterButton";

// tslint:disable-next-line:no-var-requires
const styles = require("./CashOutGraphFilters.scss");

export interface CashOutGraphFiltersProps {
    activeFilter: number;
    className?: string;
    onFilterClick: (selectedFilter: number) => void;
}

const PERIOD_5_MINUTES = 5 * 60 * 1000;
const PERIOD_15_MINUTES = 15 * 60 * 1000;

export function CashOutGraphFilters(props: CashOutGraphFiltersProps) {
    const { t } = useTranslation("cashout");
    return (
        <div className={classnames(props.className, styles.wrapper)}>
            <div className={classnames(styles.filterContainer)}>
                <ActiveFilterButton
                    active={props.activeFilter === Infinity}
                    onClick={props.onFilterClick}
                    text={t("All")}
                    filterTimespan={Infinity}
                />
                <ActiveFilterButton
                    active={props.activeFilter === PERIOD_5_MINUTES}
                    onClick={props.onFilterClick}
                    text={t("FilterPeriod", { mins: 5 })}
                    filterTimespan={PERIOD_5_MINUTES}
                />
                <ActiveFilterButton
                    active={props.activeFilter === PERIOD_15_MINUTES}
                    onClick={props.onFilterClick}
                    text={t("FilterPeriod", { mins: 15 })}
                    filterTimespan={PERIOD_15_MINUTES}
                />
            </div>
            <span> {t("BetCurrency")}</span>
        </div>
    );
}
